/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Loadmore1Inputs */

const zh_usage_loadmore1 = /** @type {(inputs: Usage_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载更多`)
};

const en_usage_loadmore1 = /** @type {(inputs: Usage_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

const es_usage_loadmore1 = /** @type {(inputs: Usage_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más`)
};

/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Usage_Loadmore1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usage_loadmore1 = /** @type {((inputs?: Usage_Loadmore1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Loadmore1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_loadmore1(inputs)
	if (locale === "en") return en_usage_loadmore1(inputs)
	return es_usage_loadmore1(inputs)
});
export { usage_loadmore1 as "usage_loadMore" }